import { NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { RouteGroupRule } from '@rocksoft/shared';
import { createDeviceTaskManagementRules } from './device-task-management.rules';
import { createLocationsRules } from './locations.rules';
import { createAppleSyncRules } from './apple-sync.rules';
import { createMdmRules } from './mdm.rules';

/**
 * Creates all device-related SignalR route group rules.
 * Register via SIGNALR_ROUTE_RULES injection token.
 */
export function createDeviceSignalRRules(store: Store, zone: NgZone): RouteGroupRule[] {
  return [
    ...createLocationsRules(store, zone),
    ...createAppleSyncRules(store, zone),
    ...createDeviceTaskManagementRules(store, zone),
    ...createMdmRules(store, zone),
  ];
}
